module.exports = __webpack_public_path__ + "img/ZLGJ.ba3ca020.png";